export default __webpack_public_path__ + "static/media/usdt.fe149544.svg";